import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/core/auth/auth.service";
import { AppConfig } from "src/config/app.config";
import { Step } from "src/app/core/step.model";
import { DatastorageService } from "src/app/datastorage.service";
import { sellPolicyData,policyPosttData } from "src/app/addpolicy/sellpolicyData.model";
import { FormGroup } from "@angular/forms";
import { CustomErrorHandler } from "src/app/core/custom-error-handler";
import { LoaderService } from "src/app/loader.service";
import { RequestIntegrity } from "src/app/core/request-integrety";
import { PayUInput } from "../core/online-transaction.model";


@Component({
  selector: 'app-plansummary',
  templateUrl: './plansummary.component.html',
  styleUrls: ['./plansummary.component.css']
})
export class PlansummaryComponent implements OnInit {
  policyNo: string;
  clientId: number;
  _apiUrl: string;
  blob: Blob;
  step: Step = new Step();
  currentYear = new Date().getFullYear();
  paymentDetailForm: FormGroup;
  sellPolicyData: sellPolicyData = new sellPolicyData();
  planName: string;
  totalPrice?: number;
  maximumVehicleAge?: string;
  durationOfPlan?: string;
  paymentForm:boolean = false;
  mobileNumber: string;
  email:string
  transactionId:string;
  buyPolicyInProgress: boolean;
  currentDate = new Date();
  policypostdata: policyPosttData = new policyPosttData();
  planId:number;
  stateName:string;
  cityName:string;
  fuelType:string;
  transmissionType:string;
  newpolicy:boolean=false;
  basicPrice:number;
  gstPercentage:number;
  isOnline:boolean=false;

  @Output() confirmPayment: EventEmitter<boolean> = new EventEmitter<boolean>();
  viewPaymentModal: boolean;
  @ViewChild('onePayuForm') onePayuFormElement;
  payuinput: PayUInput;
  payuUrl: string;

  constructor(
    private _activatedroute: ActivatedRoute,
    private authService: AuthService,
    private appConfig: AppConfig,
    private router: Router,
    private dataService: DatastorageService,
    private errorHandler: CustomErrorHandler,
    private loaderService: LoaderService,
    private requestIntegrity: RequestIntegrity
  ) {
    this._apiUrl = appConfig.baseUrl;
    this.payuUrl = appConfig.onePayuUrl;
    this.policyNo = this._activatedroute.snapshot.paramMap.get("policyNo");
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this. getAllDetails();
  }

  ngOnInit() {
    this.getAllDetails();
    this.initializeNav(3);
  }
  
  initializeNav(compltedStep: number) {
    for (let i = 0; i <= compltedStep; i++) {
      this.step.stepNumber = i;
      this.step.completed = true;
      this.dataService.nextClick.next(this.step);
    }
  }

  getplanDetails(planName) {
    this.authService
      .get(this._apiUrl + "/api/v1/plan/Getplan/" + planName)
      .subscribe(
        (response) => {
          if (response) {
            this.totalPrice = this.sellPolicyData.unitPrice;
            this.basicPrice=response.totalPrice;
            this.maximumVehicleAge = response.maximumVehicleAge;
            this.durationOfPlan = response.durationOfPlan;
            this.planName=response.planName;
            this.planId = response.planId;
            this.mobileNumber=this.sellPolicyData.customerMobileNo;
            this.email=this.sellPolicyData.customerEmail;
            this.sellPolicyData.outstandingBal = this.totalPrice;
            this.gstPercentage = Math.round(
              (parseInt(response.totalPrice) / 100) * 18
            );
          }
        },
        (error) => {
          this.errorHandler.handleError(error);
        }
      );
  }

  getAllDetails() {
    let resp = this.dataService.getData();
    if (resp) {
      this.sellPolicyData = this.dataService.getData();
      this.getplanDetails(this.sellPolicyData.policyName);
      this.getStateDetails(this.sellPolicyData.stateId);
      this.getCityDetails(this.sellPolicyData.cityId);
    }
    else{
      this.router.navigate(["/sellpolicy"]);
    }
  }

  buyNow()
  {
    let totalamount=this.basicPrice+this.gstPercentage;
    if (this.totalPrice == totalamount)
    {
    this.step.stepNumber = 2;
    this.step.completed = true;
    this.dataService.nextClick.next(this.step);
  this.dataService.setData(this.sellPolicyData);
  Object.assign(this.policypostdata, this.sellPolicyData);
    this.addBuyPolicy();
    }
    else{
      this.errorHandler.handleCustomError("Invalid price for the purchased plan.");
    }
  }
  addBuyPolicy()
  {
    this.policypostdata.transactionId = this.requestIntegrity.uuidv4();
    this.policypostdata.hash = this.requestIntegrity.HashInput(
      this.policypostdata.transactionId
    );
    var result: any;
    this.authService
    .post(
      this._apiUrl + "/api/v2/PolicyDetails/addwithoutwallet",
      this.policypostdata
    )
    .subscribe(
      (response) => {
        if (response.success) {
          result = response;
          this.policyNo = response.policyNo;
          this.transactionId=response.transactionId;
          this.step.stepNumber = 4;
          this.step.completed = true;
          this.dataService.nextClick.next(this.step);
          this.isOnline=true;
          this.dataService.clearData(this.sellPolicyData);
          this.bindPaymentInfo();
        } else {
          this.buyPolicyInProgress = false;
          this.errorHandler.handleCustomError(response.responsemsg);
          return; //exist from from all further request processing
        }
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  getStateDetails(stateId) {
    this.authService.get(this._apiUrl + '/api/v1/States/' + stateId).subscribe(response => {
      if (response) {
          this.stateName= response.stateName
      }
    }, (error) => {
      console.error(error);
    });
  }

  getCityDetails(cityId) {
    this.authService.get(this._apiUrl + "/api/v1/Cities/" + cityId).subscribe(
      (response) => {
        if (response) {
            this.cityName= response.cityName           
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
  
  bindPaymentInfo() {
    if (this.sellPolicyData.customerEmail == null || this.sellPolicyData.customerEmail == undefined) {
        this.sellPolicyData.customerEmail = 'mbitestsupport@support.com';
      }
    this.payuinput = {
      key: this.appConfig.onePayuKey,
      txnid: this.transactionId,
      productinfo: "Online policy transaction",
      amount: this.totalPrice,
      email: this.sellPolicyData.customerEmail,
      firstname: this.sellPolicyData.customerFirstName,
      surl: `${this._apiUrl}/api/v2/PaymentGateway/payu/wallet/success?host=${window.location.host}`,
      furl: `${this._apiUrl}/api/v2/PaymentGateway/payu/wallet/fail?host=${window.location.host}`,
      phone: this.mobileNumber,
      hash: null,

    };
    localStorage.setItem("productinfo", this.payuinput.productinfo);
    this.payuinput.hash = this.generateHash(this.payuinput);
    this.paymentForm = true;
    this.addPaymentLog();
  }

  addPaymentLog() {
    var payuLog: PayUInput = {};
    payuLog.txnid = this.payuinput.txnid;
    payuLog.amount = this.payuinput.amount;

    this.authService
      .post(
        this.appConfig.baseUrl + "/api/v2/PaymentGateway/PayuTransactionLogs",
        payuLog
      )
      .subscribe(
        (response) => {
          this.swithview();
          this.onePayuFormSubmit();
        },
        (error) => {
          this.errorHandler.handleError(error);
          this.errorHandler.handleCustomError("Error occured while updating PayU transaction initiated details.");
        }
      );
  }

  generateHash(payuinput: PayUInput) {
    return this.requestIntegrity.HashInput(
      `${payuinput.key}|${payuinput.txnid}|${payuinput.amount}|${payuinput.productinfo}|${payuinput.firstname}|${payuinput.email}|||||||||||${this.appConfig.onePayuSalt}`
    );
  }

  //Workaround as without delay the redirection not works
  async swithview() {
    await delay(300);
    this.confirmPayment.emit(true);
    this.loaderService.hide();
  }

  //Redirect to One PayU Page after Transaction Initiated in Transaction Wallet Details
  public onePayuFormSubmit(): void {
    this.onePayuFormElement.nativeElement.submit();
  }

  checkPaymentStatus() {
    this.authService.get(this._apiUrl + '/api/v1/PolicyDetails/CheckPaymentStatus/' + this.transactionId).subscribe(response => {
      if (response) {
          if(response.policyStatusId == 1)
          {
            this.step.stepNumber = 5;
            this.step.completed = true;
            this.dataService.nextClick.next(this.step);
            this.router.navigate([
              "/sellpolicy/download/" + this.transactionId,
            ]);
          }
          else
          {
          this.errorHandler.handleCustomInfo(
            "Payment transaction not completed by the customer. Please Wait!"
          )
        }
      }
    }, (error) => {
      console.error(error);
      this.errorHandler.handleCustomInfo(
        "Something went wrong in payment status. Please Wait!"
      )
    });
  }

}

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
